import { canv } from '@/canv/global.js'
import { IMAGE_FORMATS } from '@/constants.js'

export class settingsWindowItem {

    constructor(panelLevel, codeName) {
        this.panelLevel = panelLevel;
        this.codeName = codeName;
        this.setNames();
    }

    setNames() {
        let actionSymbol = canv.actionManager.actionSymbol;

        if (this.codeName == "backToFiles") {
            this.name = "К доскам";
            this.shortcut = "";
        } else if (this.codeName == "share") {
            this.name = "Поделиться";
            this.shortcut = "";
        } else if (this.codeName == "navigation") {
            this.name = "Навигация";
            this.shortcut = "&#62";
        }  else if (this.codeName == "shortcuts") {
            this.name = "Горячие клавиши";
            this.shortcut = "";
        } else if (this.codeName == "edit") {
            this.name = "Изменить";
            this.shortcut = "&#62";
        } else if (this.codeName == "view") {
            this.name = "Вид";
            this.shortcut = "&#62";
        } else if (this.codeName == "placeImage") {
            this.name = "Загрузить картинку";
            this.shortcut = "";
        } else if (this.codeName == "undo") {
            this.name = "Шаг назад";
            this.shortcut = actionSymbol + " Z";
        } else if (this.codeName == "redo") {
            this.name = "Шаг вперед";
            this.shortcut = actionSymbol + " Shift Z";
        } else if (this.codeName === 'cut') {
            this.name = 'Вырезать';
            this.shortcut = actionSymbol + ' X';
        } else if (this.codeName == "copy") {
            this.name = "Скопировать";
            this.shortcut = actionSymbol + " C";
        } else if (this.codeName == "paste") {
            this.name = "Вставить";
            this.shortcut = actionSymbol + " V";
        } else if (this.codeName == "selectAll") {
            this.name = "Выбрать все";
            this.shortcut = actionSymbol + " A";
        } else if (this.codeName == "zoomIn") {
            this.name = "Приблизить";
            this.shortcut = "";
        } else if (this.codeName == "zoomOut") {
            this.name = "Отдалить";
            this.shortcut = "";
        } else if (this.codeName == "zoomTo100") {
            this.name = "Сбросить зум";
            this.shortcut = actionSymbol + " 0";
        } else if (this.codeName == "zoomToSelection") {
            this.name = "Приблизить к выделенному";
            this.shortcut = "";
        } else if (this.codeName == "arrange") {
            this.name = "Выровнять";
            this.shortcut = "&#62";
        } else if (this.codeName == "alignLeft") {
            this.name = "Левый край";
            this.shortcut = "";
        } else if (this.codeName == "alignHCenters") {
            this.name = "Центры горизонтально";
            this.shortcut = "";
        } else if (this.codeName == "alignRight") {
            this.name = "Правый край";
            this.shortcut = "";
        } else if (this.codeName == "alignTop") {
            this.name = "Верхний край";
            this.shortcut = "";
        } else if (this.codeName == "alignVCenters") {
            this.name = "Центры вертикально";
            this.shortcut = "";
        } else if (this.codeName == "alignBottom") {
            this.name = "Нижний край";
            this.shortcut = "";
        } else if (this.codeName == "navTrackpad") {
            this.name = "Trackpad режим";
            this.shortcut = "";
        } else if (this.codeName == "navMouse") {
            this.name = "Mouse режим";
            this.shortcut = "";
        }
    }

    getTempalate() {
        if (this.codeName == "backToFiles") {
            return this.getBasicTemplate(true);
        } else if (this.codeName == "share") {
            return this.getBasicTemplate();
        } else if (this.codeName == "navigation") {
            return this.getBasicTemplate();
        } else if (this.codeName == "shortcuts") {
            return this.getBasicTemplate();
        } else if (this.codeName == "edit") {
            return this.getBasicTemplate();
        } else if (this.codeName == "view") {
            return this.getBasicTemplate();
        } else if (this.codeName == "placeImage") {
            return this.getPlaceImageTemplate();
        } else if (this.codeName == "undo") {
            return this.getBasicTemplate();
        } else if (this.codeName == "redo") {
            return this.getBasicTemplate(true);
        } else if (this.codeName === 'cut') {
            return this.getBasicTemplate();
        } else if (this.codeName == "copy") {
            return this.getBasicTemplate();
        } else if (this.codeName == "paste") {
            return this.getBasicTemplate();
        } else if (this.codeName == "selectAll") {
            return this.getBasicTemplate();
        } else if (this.codeName == "zoomIn") {
            return this.getBasicTemplate();
        } else if (this.codeName == "zoomOut") {
            return this.getBasicTemplate();
        } else if (this.codeName == "zoomTo100") {
            return this.getBasicTemplate();
        } else if (this.codeName == "zoomToSelection") {
            return this.getBasicTemplate();
        } else if (this.codeName == "arrange") {
            return this.getBasicTemplate(true);
        } else if (this.codeName == "alignLeft") {
            return this.getBasicTemplate();
        } else if (this.codeName == "alignHCenters") {
            return this.getBasicTemplate();
        } else if (this.codeName == "alignRight") {
            return this.getBasicTemplate();
        } else if (this.codeName == "alignTop") {
            return this.getBasicTemplate();
        } else if (this.codeName == "alignVCenters") {
            return this.getBasicTemplate();
        } else if (this.codeName == "alignBottom") {
            return this.getBasicTemplate();
        } else if (this.codeName == "navTrackpad") {
            return this.getNavigationTemplate("navTrackpad");
        } else if (this.codeName == "navMouse") {
            return this.getNavigationTemplate("navMouse");
        }
    }





    getBasicTemplate(needDividor = false) {

        var ifDividor = ``;

        if (needDividor) {
            ifDividor = `<div class="settingsWindow_dividor"></div>`;
        }


        return `

                <div class="settingsWindowItem settingsWindowItem_` + this.panelLevel + `" codeName=` + this.codeName + `>
                    <p class="settingsWindowItem_name">` + this.name + `</p>
                    <p class="settingsWindowItem_shortcut">` + this.shortcut + `</p>
                </div>
                ` + ifDividor + `

            `;
    }

    getBasicToggleTemplate(needDividor = false) {

        var status = this.getStatus();

        if (!status) {
            return this.getBasicTemplate(needDividor);
        }



        var ifDividor = ``;

        if (needDividor) {
            ifDividor = `<div class="settingsWindow_dividor"></div>`;
        }


        return `

                <div class="settingsWindowItem settingsWindowItem_toggle settingsWindowItem_` + this.panelLevel + `" codeName=` + this.codeName + `>
                    <div class="settingsWindowItem_setted"></div>
                    <p class="settingsWindowItem_name">` + this.name + `</p>
                </div>
                ` + ifDividor + `

            `;
    }

    getPlaceImageTemplate() {
        return `
                <div class="settingsWindowItem settingsWindowItem_` + this.panelLevel + `" codeName=` + this.codeName + `>
                    <p class="settingsWindowItem_name">` + this.name + `</p>
                    <p class="settingsWindowItem_shortcut">` + this.shortcut + `</p>
                    <input type="file" class="settingsWindowItemImage" accept="${IMAGE_FORMATS.join(',')}" multiple>
                </div>
            `;
    }


    getStatus() {
        // if (this.codeName == "multiplayerCursors") {
        //     return this.getMultiplayerCursorsStatus();
        // }
    }

    getMultiplayerCursorsStatus() {
        return !canv.multiManager.disableMultiCursors;
    }

    getNavigationTemplate(codename) {
        var choosenClass = ``;
        var desription = `Для перемещения двигайте двумя пальцами по трекпаду.<br>Для зума выполните на трекпаде жест, который используете на смартфоне для зума.`;
        if (codename == "navMouse") {
            desription = `Для перемещения зажмите правую кнопку мыши и двигайте мышь.<br>Для зума используйте колесико мыши.`;
        }

        if (codename == "navTrackpad" && canv.actionManager.mode == "trackpad") {
            choosenClass = `settingsWindowItem_nav_choosen`;
        }

        if (codename == "navMouse" && canv.actionManager.mode == "mouse") {
            choosenClass = `settingsWindowItem_nav_choosen`;
        }

        return `

                <div class="settingsWindowItem ` + choosenClass + ` settingsWindowItem_toggle settingsWindowItem_` + this.panelLevel + `" codeName=` + this.codeName + `>
                    <div class="settingsWindowItem_nav_circle"></div>
                    <div class="settingsWindowItem_nav">
                        <p class="settingsWindowItem_name">` + this.name + `</p>
                        <p class="settingsWindowItem_nav_descr">` + desription + `</p>
                    </div>
                </div>
            `;
    }




    panelLevel = 0;
    codeName = "";
    name = "";
    shortcut = "";
}
